import Modal from "antd/lib/modal/Modal";

export default function KuehModal({ title, visible, onCancel, footer, width, maskClosable, tasks }) {
    if (maskClosable == null) maskClosable = true

    return (
        <Modal
            visible={visible}
            title={title}
            centered
            onCancel={onCancel}
            footer={footer}
            width={width}
            maskClosable={maskClosable}
        >
            <p className="text-xl mb-4 text-justify">Unlock more kueh as you help more customers with their CPF-related tasks!</p>
            
            <div className="grid grid-cols-2 gap-4">
                { tasks.map((t, index) => {
                    return (
                        <div key={index} className="m-2">
                            {window.localStorage.getItem(t.id)
                                ? 
                                <div className="items-center flex flex-col">
                                    <img src={t.reward} alt="kueh"/>
                                </div>
                                
                                : <img src={t.reward} alt="kueh" className="black"/>
                            }
                        </div>
                        
                    );
                })}
            </div>

        </Modal>
    )
}